<div
   *ngIf="hospitalInfo"
   class="hospital-info-container">
   <div class="hospital-info-row">
      <div class="hospital-info-item">
         <span class="label">Hospital</span>
         <span class="value">{{ hospitalInfo.practiceName }}</span>
      </div>
      <div class="hospital-info-right-group">
         <div class="hospital-info-item">
            <span class="label">Hospital Manager</span>
            <span class="value">{{ hospitalInfo.hmDisplayName }}</span>
         </div>
         <div class="hospital-info-item">
            <span class="label">Chief of Staff</span>
            <span class="value">{{ hospitalInfo.cosDisplayName }}</span>
         </div>
         <div class="hospital-phone-item">
            <span class="label">Phone</span>
            <span class="value">{{ hospitalInfo.practicePhone }}</span>
         </div>
      </div>
   </div>

   <div class="hospital-info-row hospital-info-row--bottom">
      <div class="hospital-hour-item">
         <span class="label">Mon</span>
         <span class="value">{{ hospitalInfo.monHours }}</span>
      </div>
      <div class="hospital-hour-item">
         <span class="label">Tue</span>
         <span class="value">{{ hospitalInfo.tueHours }}</span>
      </div>
      <div class="hospital-hour-item">
         <span class="label">Wed</span>
         <span class="value">{{ hospitalInfo.wedHours }}</span>
      </div>
      <div class="hospital-hour-item">
         <span class="label">Thu</span>
         <span class="value">{{ hospitalInfo.thuHours }}</span>
      </div>
      <div class="hospital-hour-item">
         <span class="label">Fri</span>
         <span class="value">{{ hospitalInfo.friHours }}</span>
      </div>
      <div class="hospital-hour-item">
         <span class="label">Sat</span>
         <span class="value">{{ hospitalInfo.satHours }}</span>
      </div>
      <div class="hospital-hour-item">
         <span class="label">Sun</span>
         <span class="value">{{ hospitalInfo.sunHours }}</span>
      </div>
   </div>

   <div class="hospital-info-bar"></div>
</div>
